import type { Ref } from 'vue'
import { ref, onBeforeUpdate } from 'vue'

export function useRefs(): [Ref<HTMLElement[]>, (index: number) => (el: HTMLElement) => void] {
  const refs = ref([]) as Ref<HTMLElement[]>

  onBeforeUpdate(() => {
    refs.value = []
  })

  const setRefs = (index: number) => (el: HTMLElement) => {
    refs.value[index] = el
  }

  return [refs, setRefs]
}

// 这个hook是动态给ref赋值为refs对象的一个属性。
export function useRefsObject(): [Ref<any>, (index: string) => (el: any) => void] {
  const refs = ref({}) as Ref<any>

  const setRefs = (index: string) => (el: any) => {
    refs.value[index] = el
  }

  return [refs, setRefs]
}
